export default "__VITE_ASSET__sU$rDVR0__"